import { AuthService } from '../../core/auth.service';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Device } from '../../models/device';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DevicesService {
  devicesChanged = new Subject<number>();
  constructor(private http: HttpClient, private authService: AuthService) {}
  private devicesUrl = environment.baseUrl + environment.api + 'dslocate/devices';
  private devicesInformationUrl =
    environment.baseUrl + environment.api + 'dslocate/devices_information';
  postDevice(postDeviceData: {
    deviceId: string;
    locatorPin: number;
  }): Observable<string> {
    return this.http
      .post<string>(this.devicesUrl, postDeviceData, {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((result: any) => result.status),
        tap((status) => {
          this.devicesChanged.next(1);
        })
      );
  }

  putDeviceConfig(deviceData: Device): Observable<string> {
    return this.http
      .put<string>(
        this.devicesUrl + `/${deviceData.id}/send_config`,
        deviceData,
        {
          headers: this.authService.getJwtAuthHeaders(),
        }
      )
      .pipe(
        map((result: any) => result.status),
        tap((status) => {
          this.devicesChanged.next(1);
        })
      );
  }

  putDeviceInformation(
    id: string,
    deviceInformationData: {
      description: string;
    }
  ): Observable<string> {
    return this.http
      .put<string>(
        this.devicesInformationUrl + `/${id}`,
        deviceInformationData,
        {
          headers: this.authService.getJwtAuthHeaders(),
        }
      )
      .pipe(
        map((result: any) => result.status),
        tap((status) => {})
      );
  }

  getDevices(): Observable<Device[]> {
    return this.http
      .get<Device[]>(this.devicesInformationUrl, {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((res: any[]) => {
          return res.map((device) => {
            return {
              ...device,
              idHex: this.decimalToHexString(device.id),
            };
          });
        })
      );
  }
  decimalToHexString = (decimalValue: number) => {
    if (decimalValue < 0) {
      decimalValue = 0xffff + decimalValue + 1;
    }

    return decimalValue.toString(16).toUpperCase();
  };
}
